(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. glass header on scroll ---- */
  var header = document.querySelector('header, [class*="header"] header, .header');
  if (header){
    var onScroll = function(){
      if (window.scrollY > 40) header.classList.add('sp-glass');
      else header.classList.remove('sp-glass');
    };
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ---- 2. hero headline: wrap last word for gradient accent ---- */
  var h = document.querySelector('[class*="slideshow"] h1, [class*="slideshow"] h2');
  if (h && !h.querySelector('.sp-accent')){
    var words = h.textContent.trim().split(/\s+/);
    if (words.length > 1){
      var last = words.pop();
      h.innerHTML = words.join(' ') + ' <span class="sp-accent">' + last + '</span>';
    }
    if (!reduced) h.classList.add('sp-hero-anim');
  }
})();

